// NationalPartyShareBar.jsx
import { Box } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  LabelList,
} from "recharts";

// Colours to match your screenshot
const PARTY_COLOURS = {
  TPM: "#CC0033",
  Green: "#00843D",
  Labour: "#D33F2A",
  NZF: "#000000",
  ACT: "#FFD400",
  National: "#0057B8",
  OTH: "#778899", // optional if you ever include Others
};

// Custom label: party on first line, % on second line (white, centred)
function SegmentLabel({ x, y, width, height, value, name }) {
  // Hide labels if the slice is too thin
  if (width < 20) return null;

  const cx = x + width / 2;
  const cy = y + height / 2;

  const pctText = `${Math.round(value)}%`;

  // If very narrow, only show % to avoid wrapping
  const onlyPct = width < 10;

  return (
    <g style={{ pointerEvents: "none" }}>
      {!onlyPct && (
        <text
          x={cx}
          y={cy - 6}
          textAnchor="middle"
          dominantBaseline="central"
          fill="#fff"
          fontWeight="700"
          fontSize="10"
        >
          {name}
        </text>
      )}
      <text
        x={cx}
        y={onlyPct ? cy : cy + 8}
        textAnchor="middle"
        dominantBaseline="central"
        fill="#fff"
        fontWeight="600"
        fontSize="10"
      >
        {pctText}
      </text>
    </g>
  );
}

export default function NationalPartyShareBar({metricRowsConst, metricRowsNat,selectedFeature,WIDTH }) {
    if(!metricRowsNat){return}

    
  // Expect a single row with fields like tpm_pred_n, green_pred_n, etc.
  let row
  if(selectedFeature && metricRowsConst){
    row = metricRowsConst.filter(
                                (g) => Number(g.area_id) === Number(selectedFeature.area_id)
                                )[0]

  }else{  
  row = metricRowsNat?.[0] || {};
}
  // Helper: convert to 0–100 if values come in 0–1
  const toPct = (v) => {
    if (v == null || Number.isNaN(v)) return 0;
    const num = Number(v);
    return num;
  };

  // Build a single data point that Recharts will stack into one bar
  const data = [
    {
      id: "NationalRow",
      TPM: toPct(row.tpm_pred_n),
      Green: toPct(row.green_pred_n),
      Labour: toPct(row.lab_pred_n),
      NZF: toPct(row.nzf_pred_n),
      ACT: toPct(row.act_pred_n),
      National: toPct(row.nat_pred_n),
      // OTH: toPct(row.oth_pred_n), // include if you want an Others slice
    },
  ];


  // Ordered left→right to match your screenshot
  const SERIES = ["TPM", "Green", "Labour", "NZF", "ACT", "National"]; // add "OTH" at end if needed

  return (
    <Box sx={{display: "flex",
    justifyContent: "center", // centers horizontally
    alignContent:"center",
    width:WIDTH,
   
    px:0



    }}>
      <ResponsiveContainer width="100%" height={48}
          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
          barCategoryGap={0}
        >
          {/* Hide axes but keep domain 0–100 so the bar length reflects % */}
          <XAxis type="number" domain={[0, 100]} hide />
          <YAxis type="category" dataKey="id" hide />

          {SERIES.map((key, idx) => (
            <Bar
              key={key}
              dataKey={key}
              stackId="TOTAL"
              fill={PARTY_COLOURS[key] || "#ccc"}
              stroke="#ffffff"              // thin white separators between slices
              strokeWidth={2}
              radius={
                idx === 0
                  ? [6, 0, 0, 6]           // rounded left end
                  : idx === SERIES.length - 1
                  ? [0, 6, 6, 0]           // rounded right end
                  : [0, 0, 0, 0]
              }
              isAnimationActive={false}     // looks crisper for compact bars
            >
              <LabelList
                dataKey={key}
                content={(props) => (
                  <SegmentLabel {...props} name={key} />
                )}
              />
            </Bar>
          ))}
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}
